import React, { RefObject, useCallback } from 'react';

import { desktopItemMaxWidthVal } from '../../../constants';

import * as S from './styles';
import { ButtonSize } from '@prisjakt/ui/button';
import { IconChevronLeft, IconChevronRight } from '@prisjakt/ui/icon';

type OwnProps = {
  position?: number;
  contentRef: RefObject<HTMLDivElement>;
  setPosition: (position: number) => void;
};

const ChevronButtons = ({
  position = 0,
  contentRef,
  setPosition,
}: OwnProps) => {
  const SCROLL_AMOUNT = desktopItemMaxWidthVal;

  const scroll = useCallback(
    (amount: number) => {
      if (!contentRef.current) {
        return;
      }

      const newPosition = position + amount;

      contentRef.current.scrollTo({
        left: newPosition,
        behavior: 'smooth',
      });

      setPosition(newPosition);
    },
    [contentRef, position, setPosition]
  );

  const handleBackButtonClick = useCallback(() => scroll(-SCROLL_AMOUNT), [
    scroll,
    SCROLL_AMOUNT,
  ]);
  const handleForwardButtonClick = useCallback(() => scroll(SCROLL_AMOUNT), [
    scroll,
    SCROLL_AMOUNT,
  ]);

  return (
    <S.ButtonsWrapper>
      <S.ChevronButtons>
        <S.Button
          hidden={!contentRef.current || position === 0}
          onClick={handleBackButtonClick}
          tabIndex={0}
          left
          size={ButtonSize.SMALL}
        >
          <IconChevronLeft />
        </S.Button>
        <S.Button
          hidden={
            !contentRef.current ||
            position ===
              contentRef.current.scrollWidth - contentRef.current.clientWidth
          }
          onClick={handleForwardButtonClick}
          tabIndex={0}
          right
          size={ButtonSize.SMALL}
        >
          <IconChevronRight />
        </S.Button>
      </S.ChevronButtons>
    </S.ButtonsWrapper>
  );
};

export default ChevronButtons;
